// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Formik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import {
  useFindServiceProviderDetailByIdMutation,
  useGetAllServiceProviderDetailMutation,
  useSaveServiceProviderDetailMutation,
  useUpdateServiceProviderDetailMutation,
  useUploadFormMutation,
} from '../../store/api/serviceProviderApi';
import * as Yup from 'yup';
import { Box, Button, Container, MenuItem, Select, Stack, TextField, Tooltip, Typography } from '@mui/material';
import Page from '../../components/Page';
import { setServiceProvider } from '../../store/state/serviceProviderSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import Loading from '../../components/Loading';
import { useGetEnumDataMutation } from '../../store/api/enumApi';
import {
  useUploadServiceProviderDocMutation,
  useFindByParkingLocationIdDocMutation,
  useDeleteServiceProviderDocMutation,
} from '../../store/api/uploadDocumentApi';
import { getSpecificEnumData, setEnumData } from '../../store/state/enumSlice';
import ibutton from '../../../src/assets/static/mock-images/logo/ibutton.png';
import {
  splitName,
  last4Character,
  last4CharacterSsn,
  checkPermissions,
  onlyLastFourNum,
  onlyLastEmailShow,
} from '../../sections/@dashboard/parkingspaces/utility';
import { PERMISSION } from '../../utils/userPermission';
import DeleteIcon from '@mui/icons-material/Delete';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

const ServiceProviderSchema = Yup.object().shape(
  {
    name: Yup.string().required('Name is required').trim(),
    contactNumber: Yup.string()
      .required('This field is required')
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        'Phone number is not valid'
      )
      .min(10, 'Contact Number must be 10 digits')
      .max(10, 'Contact Number must be 10 digits')
      .trim(),
    secondaryContactNumber: Yup.string()
      .required('Alternative contact number is required')
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        'Please enter a valid phone number'
      )
      .min(10, 'Alternative contact number must be 10 digits')
      .max(10, 'Alternative contact number must be 10 digits')
      .trim(),
    emailId: Yup.string().email('Invalid email').required('Email is required').trim(),
    businessName: Yup.string().required('Business name is required').trim(),
    address: Yup.string().required('Address is required').trim(),
    city: Yup.string().required('City is required').trim(),
    state: Yup.string().required('State is required').trim(),
    country: Yup.string().required('Country is required').trim(),
    ZIPCode: Yup.string().required('ZIP Code is required').trim(),
    listAccountNumber: Yup.string()
      .optional()
      .nullable()
      .matches(/^[0-9]+(\.?[0-9]+)?$/, {
        message: 'List Account Number must be number',
      })
      .trim(),
    // listAccountNumber: Yup.string()
    //   .optional()
    //   .nullable()
    //   .matches(/^[0-9]+(\.?[0-9]+)?$/, {
    //     message: 'List Account Number must be number',
    //   })
    //   .trim(),
    aadharCard: Yup.string()
      .required(' Aadhar is required')
      .matches(/^\d{4}\d{4}\d{4}$/, '  Aadhar number is not valid')
      .trim(),
    employerIdentificationNumber: Yup.string()
      .required('PAN card number is required')
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, 'PAN card number is not valid')
      .trim(),
    gstNo: Yup.string()
      .required(' GST is required')
      .matches(/\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/, ' GST is not valid')
      .trim(),
    companyTypeList: Yup.string().required('Select atleast one option'),
    businessType: Yup.string().required('Select atleast one option'),
    accountType: Yup.string().required('Select atleast one option'),
    // taxClassification: Yup.string()
    //   .when('companyTypeList', {
    //     is: (companyTypeList: any) => companyTypeList == 'CTMLLC',
    //     then: Yup.string()
    //       .required('Field is required')
    //       .matches(/[C S P]/, { message: 'Only alphabets C, S, P are allowed for this field' }),
    //     otherwise: Yup.string(),
    //   })
    //   .trim(),
    commission: Yup.string()
      .required('Commission is required')
      .matches(/^[0-9]+(\.?[0-9]+)?$/, { message: 'Invalid number' })
      .trim(),
    // convenienceFee: Yup.string()
    //   .required('Convenience Fee is required')
    //   .matches(/^[0-9]+(\.?[0-9]+)?$/, { message: 'Invalid number' })
    //   .trim(),
    cinNumber: Yup.string()
      .required('CIN is required')
      .matches(
        /^[LUlu]\d{5}[A-Za-z]{2}\d{4}[A-Za-z]{3}\d{6}$/,
        'Enter a valid CIN'
      ),
    bankName: Yup.string()
      .required('Bank name is required'),

    bankRecipientName: Yup.string()
      .required('Recipient name is required'),

    bankIfscCode: Yup.string()
      .required('IFSC code is required')
      .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC code'),

    listAccountNumber: Yup.string()
      .required('Account number is required')
      .matches(/^\d{9,18}$/, 'Account number must be 9 to 18 digits'),
  },

);

const ServiceProviderSchemaEdit = Yup.object().shape(
  {
    name: Yup.string().required('Name is required').trim(),
    contactNumber: Yup.string()
      .required('Contact number is required')
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        'Phone number is not valid'
      )
      .min(10, 'Contact Number must be 10 digits')
      .max(10, 'Contact Number must be 10 digits')
      .trim(),
    secondaryContactNumber: Yup.string()
      .required('Alternative contact number is required')
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        'Please enter a valid phone number'
      )
      .min(10, 'Alternative contact number must be 10 digits')
      .max(10, 'Alternative contact number must be 10 digits')
      .trim(),
    emailId: Yup.string().email().required('Email is required').trim(),
    businessName: Yup.string().required('Business Name is required').trim(),
    address: Yup.string().required('Address is required').trim(),
    city: Yup.string().required('City is required').trim(),
    state: Yup.string().required('State is required').trim(),
    country: Yup.string().required('Country is required').trim(),
    ZIPCode: Yup.string().required('ZIP Code is required').trim(),
    aadharCard: Yup.string()
      .required(' Aadhar is required')
      .matches(/^\d{4}\d{4}\d{4}$/, '  Aadhar number is not valid')
      .trim(),
    listAccountNumber: Yup.string()
      .optional()
      .nullable()
      .matches(/^[0-9]+(\.?[0-9]+)?$/, {
        message: 'List Account Number must be number',
      })
      .trim(),
    employerIdentificationNumber: Yup.string()
      .required('PAN card number is required')
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, 'PAN card number is not valid')
      .trim(),
    gstNo: Yup.string()
      .required(' GST is required')
      .matches(/\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/, ' GST is not valid')
      .trim(),
    companyTypeList: Yup.string().required('Select atleast one option'),
    businessType: Yup.string().required('Select atleast one option'),
    accountType: Yup.string().required('Select atleast one option'),
    // taxClassification: Yup.string()
    //   .when('companyTypeList', {
    //     is: (companyTypeList: any) => companyTypeList == 'CTMLLC',
    //     then: Yup.string()
    //       .required('This field is required')
    //       .matches(/[C S P]/, { message: 'Only alphabets C, S, P are allowed for this field' }),
    //     otherwise: Yup.string(),
    //   })
    //   .trim(),
    // convenienceFee: Yup.string()
    //   .required('Convenience Fee is required')
    //   .matches(/^[0-9]+(\.?[0-9]+)?$/, { message: 'Invalid number' })
    //   .trim(),
    commission: Yup.string()
      .required('Commission is required')
      .matches(/^[0-9]+(\.?[0-9]+)?$/, { message: 'Invalid number' })
      .trim(),
    cinNumber: Yup.string()
      .required('CIN is required')
      .matches(
        /^[LUlu]\d{5}[A-Za-z]{2}\d{4}[A-Za-z]{3}\d{6}$/,
        'Enter a valid CIN'
      ),
    bankName: Yup.string()
      .required('Bank name is required'),

    bankRecipientName: Yup.string()
      .required('Recipient name is required'),

    bankIfscCode: Yup.string()
      .required('IFSC code is required')
      .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC code'),

    listAccountNumber: Yup.string()
      .required('Account number is required')
      .matches(/^\d{9,18}$/, 'Account number must be 9 to 18 digits'),
  },
);

export default function AddVendor() {
  const dispatch = useAppDispatch();
  const [formValues, setFormValues] = useState({
    name: '',
    bankName: '',
    bankAccountType: '',
    bankRecipientName: '',
    bankIfscCode: '',
    contactNumber: '',
    emailId: '',
    businessName: '',
    exemptPayeeCode: '',
    exemptionFromFATCAReportingCode: '',
    address: '',
    city: '',
    state: '',
    country: '',
    ZIPCode: '',
    listAccountNumber: '',
    socialSecurityNumber: '',
    employerIdentificationNumber: '',
    taxClassification: '',
    other: '',
    gstNo: '',
    companyTypeList: '',
    status: false,
    currentStatus: 'Pending',
    commission: '',
    vendorAlias: '',
    aadharCard: '',
    convenienceFee: '',
    secondaryContactNumber: '',
    cinNumber: '',
    accountType: '',
    businessType: '',
  });
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const navigate = useNavigate();
  const [saveServiceProviderDetail, saveResponse] = useSaveServiceProviderDetailMutation();
  const [getAllServiceProviderDetail, getAllResponse] = useGetAllServiceProviderDetailMutation();
  const [findServiceProviderDetailById, findByIdResponse] = useFindServiceProviderDetailByIdMutation();
  console.log(findByIdResponse, "findByIdResponse");
  const [updateServiceProviderDetail, updateResponse] = useUpdateServiceProviderDetailMutation();
  const { state } = useLocation();
  const [page, setPage] = useState(0);
  const [offset, setOffset] = useState(5);
  const [orderBy, setOrderBy] = useState('asc');
  const [columName, setColumName] = useState('id');
  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  let enumData: any = useAppSelector(getSpecificEnumData);
  const [check, setCheck] = useState([]);
  const [checkData, setcheckData] = useState([]);
  const authData = JSON.parse(localStorage.getItem('login') || '{}');
  const [checkDataT, setCheckDataT] = useState('');
  const [from, setFrom] = useState('');
  const [uploadForm, uploadFormResponse] = useUploadServiceProviderDocMutation();
  const [getDocumentForm, getDocumentResponse] = useFindByParkingLocationIdDocMutation();
  const [deleteDocument, deleteDocumentRes] = useDeleteServiceProviderDocMutation();
  const fileInputForW9: any = useRef();
  const fileInputForContract: any = useRef();
  const [selectedFileForW9, setSelectedFileForW9] = useState<null | any>(null);
  const [w9FilePath, setW9FilePath] = useState([]);
  const [forms2Value, setForms2Value] = useState({
    name: '',
  });
  const [PanCardUrl, setPanCardUrl]: any = useState(null);
  const [GSTUrl, setGSTdUrl] = useState(null);
  const [AaharUrl, setAahardUrl] = useState(null);
  const [contractUrl, setContractdUrl] = useState(null);
  const [isImgUrl, setIsImgUrl] = useState(false);
  const [businessType, setBusinessType] = useState([]);
  const [accountType, setAccountType] = useState([]);

  useEffect(() => {
    getEnumData({ token: token.token });
  }, []);

  useEffect(() => {
    if (state.editMode === true || state.isApproved === true) {
      getDocumentForm({ token: token.token, serviceProviderId: state.id });
    }
  }, []);

  useEffect(() => {
    if (deleteDocumentRes.isSuccess) {
      getDocumentForm({ token: token.token, serviceProviderId: state.id });
    }
  }, [deleteDocumentRes.isSuccess]);

  useEffect(() => {
    if (getDocumentResponse.isSuccess) {
      setW9FilePath(getDocumentResponse.data);

      getDocumentResponse.data &&
        getDocumentResponse.data.filter((item) => {
          if (item.docType === 'PANCARD') {
            setPanCardUrl(item.filePreSignedUrl);
          }
        });
      getDocumentResponse.data &&
        getDocumentResponse.data.filter((item) => {
          if (item.docType === 'GST') {
            setGSTdUrl(item.filePreSignedUrl);
          }
        });
      getDocumentResponse.data &&
        getDocumentResponse.data.filter((item) => {
          if (item.docType === 'AADHAR') {
            setAahardUrl(item.filePreSignedUrl);
          }
        });
      getDocumentResponse.data &&
        getDocumentResponse.data.filter((item) => {
          if (item.docType === 'CONTRACT') {
            setContractdUrl(item.filePreSignedUrl);
          }
        });
      getDocumentResponse.data &&
        getDocumentResponse.data.filter((item) => {
          if (item.docType === 'COMPANY_LOGO') {
            setIsImgUrl(item.filePreSignedUrl);
          }
        });
    }
  }, [getDocumentResponse.isSuccess, getDocumentResponse.isError]);

  useEffect(() => {
    if (enumResponse.isSuccess) {
      dispatch(setEnumData(enumResponse.data));
    }
    if (enumResponse.isError) {
      let errorData: any = enumResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [enumResponse.isSuccess, enumResponse.isError]);

  useEffect(() => {
    if (enumData) {
      setcheckData(enumData['COMPANY_TYPE']);
      setBusinessType(enumData['BUSINESS_TYPE'])
      setAccountType(enumData['ACCOUNT_TYPE'])
    }
  }, [enumData]);

  // add
  useEffect(() => {
    if (updateResponse.isSuccess) {
      toast.success('Vendor updated successfully');
    }
    if (saveResponse.isSuccess) {
      toast.success('Vendor added successfully');
    }
  }, [updateResponse.isSuccess || saveResponse.isSuccess]);

  useEffect(() => {
    if (saveResponse.isSuccess || updateResponse.isSuccess) {
      getAllServiceProviderDetail({
        token: token.token,
        payload: {
          page: page,
          offset: offset,
          orderBy: orderBy,
          columName: columName,
        },
      });
    }
    if (saveResponse.isError || updateResponse.isError) {
      let errorData: any = saveResponse.error;
      let msg: any = errorData?.data.serviceErrors[0].msg;
      toast.error('User detail already exists. Please use different details.' || '');
    }
  }, [saveResponse.isSuccess, updateResponse.isSuccess, saveResponse.isError, updateResponse.isError]);

  // update store
  useEffect(() => {
    if (getAllResponse.isSuccess) {
      dispatch(setServiceProvider(getAllResponse.data));
      navigate('/dashboard/vendor-details');
    }
    if (getAllResponse.isError) {
      let errorData: any = getAllResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('User detail already exists. Please use different details.' + msg || '');
    }
  }, [getAllResponse.isSuccess, getAllResponse.isError]);

  // fetch details
  useEffect(() => {
    if (state.editMode || state.isApproved) {
      findServiceProviderDetailById({ id: state.id, userId: state.userId, token: token.token });
    }
  }, [state.editMode, state.isApproved]);

  // set formik initial values
  useEffect(() => {
    if (findByIdResponse.isSuccess) {
      setFormValues(() => {
        return {
          address: findByIdResponse.data.address,
          businessName: findByIdResponse.data.businessName,
          city: findByIdResponse.data.city,
          companyTypeList: findByIdResponse.data.companyTypeList,
          contactNumber: findByIdResponse.data.contactNumber,
          country: findByIdResponse.data.country,
          currentStatus: '',
          employerIdentificationNumber: findByIdResponse.data.einNumber,
          emailId: findByIdResponse.data.emailId,
          exemptionFromFATCAReportingCode: findByIdResponse.data.exemptFatca,
          filePath: findByIdResponse.data.filePath,
          contractFilePath: findByIdResponse.data.contractFilePath,
          gstNo: findByIdResponse.data.gstNo,
          taxClassification: findByIdResponse.data.llcTaxType,
          name: findByIdResponse.data.name,
          other: findByIdResponse.data.other,
          password: '',
          exemptPayeeCode: findByIdResponse.data.payeeCode,
          listAccountNumber:
            findByIdResponse.data.primaryAccountNo != null ? findByIdResponse.data.primaryAccountNo : '',
          socialSecurityNumber: findByIdResponse.data.socialSecNumber,
          state: findByIdResponse.data.state,
          status: findByIdResponse.data.status,
          tierType: '',
          vatNo: '',
          ZIPCode: findByIdResponse.data.zip,
          commission: findByIdResponse.data.commission,
          currentStatus: findByIdResponse.data.currentStatus,
          vendorAlias: findByIdResponse.data.vendorAlias,
          stripeAccountId: findByIdResponse?.data?.stripeAccountId,
          isStripeOnboarded: findByIdResponse?.data?.isStripeOnboarded,
          aadharCard: findByIdResponse?.data?.aadhaarNumber,
          convenienceFee: findByIdResponse?.data?.convenienceFee,
          bankName: findByIdResponse?.data?.bankName,
          bankRecipientName: findByIdResponse?.data?.bankRecipientName,
          bankIfscCode: findByIdResponse?.data?.bankIfscCode,
          bankAccountType: findByIdResponse?.data?.bankAccountType,
          secondaryContactNumber: findByIdResponse?.data?.secondaryContactNumber,
          cinNumber: findByIdResponse?.data?.cinNumber,
          accountType: findByIdResponse?.data?.accountType,
          businessType: findByIdResponse?.data?.businessType,
          razorpayAccountId: findByIdResponse?.data?.razorpayAccountId,
          cahFreeAccountId: findByIdResponse?.data?.cahFreeAccountId,

        };
      });
      setCheckDataT(findByIdResponse.data.companyTypeList);
      setForms2Value({
        name: findByIdResponse.data.name,
      });
    }

    console.log(formValues, "formValues");

    if (findByIdResponse.isError) {
      let errorData: any = findByIdResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [findByIdResponse.isSuccess, findByIdResponse.isError]);

  const saveServiceProviderDataToServer = async (values) => {
    await saveServiceProviderDetail({
      payload: {
        aadhaarNumber: values.aadharCard,
        address: values.address,
        businessName: values.businessName.trim(),
        city: values.city.trim(),
        commission: values.commission,
        companyTypeList: values.companyTypeList,
        contactNumber: values.contactNumber,
        secondaryContactNumber: values.secondaryContactNumber,
        country: values.country,
        einNumber: values.employerIdentificationNumber,
        emailId: values.emailId.trim(),
        exemptFatca: 0,
        llcTaxType: values.taxClassification,
        name: values.name.trim(),
        other: values.other.trim(),
        password: '',
        payeeCode: 0,
        primaryAccountNo: values.listAccountNumber,
        socialSecNumber: values.socialSecurityNumber,
        gstNo: values.gstNo,
        state: values.state.trim(),
        status: state.isApproved ? true : values.status,
        currentStatus: values.currentStatus,
        convenienceFee: values.convenienceFee,
        bankName: values.bankName,
        bankRecipientName: values.bankRecipientName,
        bankIfscCode: values.bankIfscCode,
        bankAccountType: values.bankAccountType,
        tierType: '',
        vatNo: '',
        sendEmail: true,
        zip: values.ZIPCode,
        vendorAlias: values.employerIdentificationNumber
          ? values.businessName + '-' + last4Character(values.employerIdentificationNumber)
          : values.businessName + '-' + last4CharacterSsn(values.socialSecurityNumber),
        requestFrom: '',
        cinNumber: values.cinNumber,
        accountType: values.accountType,
        businessType: values.businessType,
        razorpayAccountId: values.razorpayAccountId,
        cahFreeAccountId: values.cahFreeAccountId,
      },
      token: token.token,
    });
  };

  const updateDataInServer = async (values) => {
    await updateServiceProviderDetail({
      payload: {
        aadhaarNumber: values.aadharCard,
        address: values.address,
        businessName: values.businessName,
        city: values.city,
        commission: values.commission,
        convenienceFee: values.convenienceFee,
        companyTypeList: values.companyTypeList,
        contactNumber: values.contactNumber,
        secondaryContactNumber: values.secondaryContactNumber,
        country: values.country,
        einNumber: values.employerIdentificationNumber,
        emailId: values.emailId,
        exemptFatca: values.exemptionFromFATCAReportingCode,
        llcTaxType: values.taxClassification,
        name: values.name,
        other: values.other,
        password: '',
        payeeCode: values.exemptPayeeCode,
        primaryAccountNo: values.listAccountNumber,
        socialSecNumber: values.socialSecurityNumber,
        gstNo: values.gstNo,
        state: values.state,
        tierType: '',
        vatNo: '',
        zip: values.ZIPCode,
        bankName: values.bankName,
        bankRecipientName: values.bankRecipientName,
        bankIfscCode: values.bankIfscCode,
        bankAccountType: values.bankAccountType,
        id: state.id,
        userId: findByIdResponse?.data?.userId,
        filePath: findByIdResponse?.data?.filePath,
        contractFilePath: findByIdResponse.data.contractFilePath,
        status: state.isApproved ? true : values.status,
        sendEmail: false,
        currentStatus: state.isApproved ? 'Approved' : values.currentStatus,
        vendorAlias: values.employerIdentificationNumber
          ? values.businessName + '-' + last4Character(values.employerIdentificationNumber)
          : values.businessName + '-' + last4CharacterSsn(values.socialSecurityNumber),
        stripeAccountId: findByIdResponse?.data?.stripeAccountId,
        isStripeOnboarded: findByIdResponse?.data?.isStripeOnboarded,
        cinNumber: values.cinNumber,
        accountType: values.accountType,
        businessType: values.businessType,
        razorpayAccountId: values.razorpayAccountId,
        cahFreeAccountId: values.cahFreeAccountId,

      },
      token: token.token,
    });
  };

  const temporaryUpdateDataInServe = async (values) => {
    await updateServiceProviderDetail({
      payload: {
        aadhaarNumber: values.aadharCard,
        address: values.address,
        businessName: values.businessName,
        city: values.city,
        commission: values.commission,
        convenienceFee: values.convenienceFee,
        companyTypeList: values.companyTypeList,
        contactNumber: values.contactNumber,
        secondaryContactNumber: values.secondaryContactNumber,
        country: values.country,
        einNumber: values.employerIdentificationNumber,
        emailId: values.emailId,
        exemptFatca: values.exemptionFromFATCAReportingCode,
        llcTaxType: values.taxClassification,
        name: values.name,
        other: values.other,
        password: '',
        payeeCode: values.exemptPayeeCode,
        primaryAccountNo: values.listAccountNumber,
        socialSecNumber: values.socialSecurityNumber,
        gstNo: values.gstNo,
        state: values.state,
        tierType: '',
        vatNo: '',
        zip: values.ZIPCode,
        bankName: values.bankName,
        bankRecipientName: values.bankRecipientName,
        bankIfscCode: values.bankIfscCode,
        bankAccountType: values.bankAccountType,
        id: state.id,
        userId: findByIdResponse?.data?.userId,
        filePath: findByIdResponse?.data?.filePath,
        contractFilePath: findByIdResponse.data.contractFilePath,
        status: state.isApproved ? true : values.status,
        sendEmail: false,
        status: state.isApproved ? true : values.status,
        currentStatus: state.isApproved ? 'Pending' : values.currentStatus,
        vendorAlias: values.employerIdentificationNumber
          ? values.businessName + '-' + last4Character(values.employerIdentificationNumber)
          : values.businessName + '-' + last4CharacterSsn(values.socialSecurityNumber),
        stripeAccountId: findByIdResponse?.data?.stripeAccountId,
        isStripeOnboarded: findByIdResponse?.data?.isStripeOnboarded,
        cinNumber: values.cinNumber,
        accountType: values.accountType,
        businessType: values.businessType,
        razorpayAccountId: values.razorpayAccountId,
        cahFreeAccountId: values.cahFreeAccountId,
      },
      token: token.token,
      // payload: {
      //   address: values.address,
      //   businessName: values.businessName,
      //   city: values.city,
      //   commission: values.commission,
      //   companyTypeList: values.companyTypeList,
      //   contactNumber: values.contactNumber,
      //   country: values.country,
      //   einNumber: values.employerIdentificationNumber,
      //   emailId: values.emailId,
      //   exemptFatca: values.exemptionFromFATCAReportingCode,
      //   llcTaxType: values.taxClassification,
      //   name: values.name,
      //   other: values.other,
      //   password: '',
      //   payeeCode: values.exemptPayeeCode,
      //   primaryAccountNo: values.listAccountNumber,
      //   socialSecNumber: values.socialSecurityNumber,
      //   gstNo: values.gstNo,
      //   state: values.state,
      //   secondaryContactNumber: values.secondaryContactNumber,
      //   tierType: '',
      //   vatNo: '',
      //   zip: values.ZIPCode,
      //   id: state.id,
      //   userId: findByIdResponse?.data?.userId,
      //   filePath: findByIdResponse?.data?.filePath,
      //   contractFilePath: findByIdResponse?.data?.contractFilePath,
      //   status: state.isApproved ? true : values.status,
      //   currentStatus: state.isApproved ? 'Pending' : values.currentStatus,
      //   vendorAlias: values.employerIdentificationNumber
      //     ? values.businessName + '-' + last4Character(values.employerIdentificationNumber)
      //     : values.businessName + '-' + last4CharacterSsn(values.socialSecurityNumber),
      //   sendEmail: true,
      //   stripeAccountId: findByIdResponse?.data?.stripeAccountId,
      //   isStripeOnboarded: findByIdResponse?.data?.isStripeOnboarded,
      // },
      // token: token.token,
    });
  };

  const handleAddNewServiceProvider = (values, action) => {
    if (state.editMode) {
      updateDataInServer(values);
    } else if (state.isApproved && from === 'F') {
      updateDataInServer(values);
    } else {
      saveServiceProviderDataToServer(values);
    }
    action.resetForm();
  };
  const changeHandlerForAdhar = (event: any) => {
    const fileName = event.target.files[0].name;
    const extention = fileName.lastIndexOf('.') + 1;
    const extFile = fileName.substr(extention, fileName.length).toLowerCase();
    if (
      extFile === 'jpg' ||
      extFile === 'jpeg' ||
      extFile === 'png' ||
      extFile === 'pdf' ||
      extFile === 'docx' ||
      extFile === 'pdf'
    ) {
      setSelectedFileForW9(event.target.files[0]);
    } else {
      setSelectedFileForW9(null);
      toast.error('Only *.jpeg, *.jpg, *.png, *.pdf, *.docx files are allowed!');
    }
  };
  const changeHandlerProfileImage = (event: any) => {
    const fileName = event.target.files[0].name;
    const extention = fileName.lastIndexOf('.') + 1;
    const extFile = fileName.substr(extention, fileName.length).toLowerCase();
    if (extFile === 'jpg' || extFile === 'jpeg' || extFile === 'png') {
      setSelectedFileForW9(event.target.files[0]);
    } else {
      setSelectedFileForW9(null);
      toast.error('Only *.jpeg, *.jpg, *.png files are allowed!');
    }
  };

  const uploadFileForW9 = (docType: any) => {
    if (selectedFileForW9 !== null) {
      const formData = new FormData();
      formData.append('file', selectedFileForW9);
      const values = [...formData.entries()];
      uploadForm({
        file: formData,
        serviceProviderId: state.id,
        docType: docType,
        token: token.token,
      });
    }
  };

  useEffect(() => {
    if (uploadFormResponse.isSuccess) {
      fileInputForW9.current.value = '';
      getDocumentForm({ token: token.token, serviceProviderId: state.id });
      findServiceProviderDetailById({ id: state.id, userId: state.userId, token: token.token });
      toast.success('File added successfully.');
    }
  }, [uploadFormResponse.isSuccess]);

  return (
    <Page title="Vendor Profile">
      <Formik
        enableReinitialize={true}
        initialValues={formValues}
        onSubmit={handleAddNewServiceProvider}
        validationSchema={state.editMode ? ServiceProviderSchemaEdit : ServiceProviderSchema}
      >
        {({ values, errors, touched, setFieldValue, handleChange, handleBlur, handleSubmit, setFieldTouched ,validateForm }) => (
          <Container
            sx={{
              paddingTop: '2rem',
              paddingBottom: '2rem',
            }}
          >
            <Typography variant="h3" marginBottom={'20px'} component="div">
              {state.editMode ? 'Update Vendor' : state.isApproved ? 'Vendor Verification' : 'Add Vendor'}
            </Typography>

            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Vendor's Full Name
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="Enter vendor name"
                    name={'name'}
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                    error={Boolean(touched.name && errors.name)}
                    helperText={touched.name && errors.name}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Business Name
                  </Typography>
                  <TextField
                    disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                    sx={{ width: '80%' }}
                    placeholder="Enter vendor business name"
                    name={'businessName'}
                    value={values.businessName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.businessName && errors.businessName)}
                    helperText={touched.businessName && errors.businessName}
                  />
                </Stack>
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Vendor's Phone Number
                  </Typography>
                  <TextField
                    disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                    sx={{ width: '80%' }}
                    placeholder="Enter vendor contact number"
                    name={'contactNumber'}
                    value={
                      checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)
                        ? onlyLastFourNum(values.contactNumber)
                        : values.contactNumber
                    }
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.contactNumber && errors.contactNumber)}
                    helperText={touched.contactNumber && errors.contactNumber}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Vendor's  Alternative Phone Number
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="Enter vendor alternative phone number"
                    name={'secondaryContactNumber'}
                    value={values.secondaryContactNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.secondaryContactNumber && errors.secondaryContactNumber)}
                    helperText={touched.secondaryContactNumber && errors.secondaryContactNumber}
                  />
                </Stack>
              </Box>
            </Box>
            <Box sx={{ marginTop: '25px', marginBottom: '25px' }}>
              <Typography variant="h5" marginTop={2} gutterBottom component="div">
                Please select the appropriate option for the tax classification of the entity as per Indian tax
                regulations.
              </Typography>
              <Select
                disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                name="companyTypeList"
                id="companyTypeList"
                value={
                  checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)
                    ? onlyLastFourNum(values.companyTypeList)
                    : values.companyTypeList
                }
                className="w-[300px] md:w-[500px]"
                onChange={(event: any) => {
                  setCheckDataT(event.target.value);
                  setFieldValue('companyTypeList', event.target.value);
                }}
                error={Boolean(touched.companyTypeList && errors.companyTypeList)}
                displayEmpty
                defaultValue={''}
                sx={{ width: '40%' }}
              >
                <MenuItem disabled value="">
                  Select Option
                </MenuItem>
                {checkData &&
                  checkData.map((checkData: any) => (
                    <MenuItem key={checkData.code} value={checkData.code}>
                      {checkData.displayValue}
                    </MenuItem>
                  ))}
              </Select>
              {errors.companyTypeList && (
                <div style={{ color: 'red' }} className="text-sm">
                  {errors.companyTypeList}
                </div>
              )}
              {/* {errors.companyTypeList == 'CTMLLC' ||
                (checkDataT == 'CTMLLC' && (
                  <Box width={'100%'}>
                    <Box className=" " style={{ display: 'flex', gap: '10px' }}>
                      <Typography variant="h6" gutterBottom component="div">
                        Tax classification
                      </Typography>
                      <Tooltip
                        title="Note: Select the appropriate option in the line above
                          for the tax classification of the
                          single-member owner. Do not select LLC if the
                          LLC is classified as a single-member LLC
                          that is disregarded from the owner unless
                          the owner of the LLC is another LLC that is
                          not disregarded from the owner for Indian
                          federal tax purposes. Otherwise, a
                          single-member LLC that is disregarded from
                          the owner should select the appropriate option
                          for the tax classification of its owner."
                        placement="right-end"
                      >
                        <img style={{ height: '20px', marginTop: '5px' }} src={ibutton} />
                      </Tooltip>
                    </Box>

                    <Stack direction="column" alignItems="self-start">
                      <TextField
                        disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                        sx={{ width: '100%' }}
                        placeholder="Enter vendor tax classification"
                        name={'taxClassification'}
                        value={
                          checkPermissions(PERMISSION?.VENDOR_HIDE_DETAIL, token.permissions)
                            ? onlyLastFourNum(values?.taxClassification)
                            : values?.taxClassification
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(touched?.taxClassification && errors?.taxClassification)}
                        helperText={touched?.taxClassification && errors?.taxClassification}
                      />
                    </Stack>
                  </Box>
                ))} */}
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Vendor's Email
                  </Typography>
                  <TextField
                    disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                    sx={{ width: '80%' }}
                    placeholder="Enter vendor email id"
                    name={'emailId'}
                    value={
                      checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)
                        ? onlyLastEmailShow(values.emailId)
                        : values.emailId
                    }
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.emailId && errors.emailId)}
                    helperText={touched.emailId && errors.emailId}
                    disabled={state.editMode ? true : state.isApproved ? true : false}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Typography variant="h5" gutterBottom component="div">
                  Vendor's Address
                </Typography>
                <Stack direction="column" alignItems="self-start">
                  <TextField
                    disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                    sx={{ width: '90%' }}
                    placeholder="Enter vendor address"
                    name={'address'}
                    value={values.address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.address && errors.address)}
                    helperText={touched.address && errors.address}
                  />
                </Stack>
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    City Name
                  </Typography>
                  <TextField
                    disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                    sx={{ width: '80%' }}
                    placeholder="Vendor City Name"
                    name={'city'}
                    value={values.city}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.city && errors.city)}
                    helperText={touched.city && errors.city}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Box width="100%">
                  <Stack direction="column" alignItems="self-start">
                    <Typography variant="h5" gutterBottom component="div">
                      State Name
                    </Typography>
                    <TextField
                      disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                      sx={{ width: '90%' }}
                      placeholder="Vendor State Name"
                      name={'state'}
                      value={values.state}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.state && errors.state)}
                      helperText={touched.state && errors.state}
                    />
                  </Stack>
                </Box>
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Country Name
                  </Typography>
                  <TextField
                    disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                    sx={{ width: '80%' }}
                    placeholder="Vendor Country Name"
                    name={'country'}
                    value={values.country}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.country && errors.country)}
                    helperText={touched.country && errors.country}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Postal Code
                  </Typography>
                  <TextField
                    disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                    sx={{ width: '90%' }}
                    placeholder="Vendor Postal Code"
                    name={'ZIPCode'}
                    value={values.ZIPCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.ZIPCode && errors.ZIPCode)}
                    helperText={touched.ZIPCode && errors.ZIPCode}
                  />
                </Stack>
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Bank Name
                  </Typography>
                  <TextField
                    disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                    sx={{ width: '80%' }}
                    placeholder="Bank Name (Optional)"
                    name={'bankName'}
                    value={values.bankName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.bankName && errors.bankName)}
                    helperText={touched.bankName && errors.bankName}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Vendor's Bank Account Number
                  </Typography>
                  <TextField
                    disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                    sx={{ width: '90%' }}
                    placeholder="Vendor Bank Account Number (Optional)"
                    name={'listAccountNumber'}
                    value={
                      checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)
                        ? onlyLastFourNum(values.listAccountNumber)
                        : values.listAccountNumber
                    }
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.listAccountNumber && errors.listAccountNumber)}
                    helperText={touched.listAccountNumber && errors.listAccountNumber}
                  />
                </Stack>
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    IFSC Code
                  </Typography>
                  <TextField
                    disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                    sx={{ width: '80%' }}
                    placeholder="IFSC Code (Optional)"
                    name={'bankIfscCode'}
                    value={values.bankIfscCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.bankIfscCode && errors.bankIfscCode)}
                    helperText={touched.bankIfscCode && errors.bankIfscCode}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Recipient Name
                  </Typography>
                  <TextField
                    disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                    sx={{ width: '90%' }}
                    placeholder="Recipient Name (Optional)"
                    name={'bankRecipientName'}
                    value={values.bankRecipientName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.bankRecipientName && errors.bankRecipientName)}
                    helperText={touched.bankRecipientName && errors.bankRecipientName}
                  />
                </Stack>
              </Box>
            </Box>
            <Box display="flex" alignItems="center" marginTop={'25px'} >
              {/* Account Type */}
              <Box width="100%">
                <Typography variant="h5" gutterBottom component="div">
                  Account Type
                </Typography>
                <Select
                  disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)}
                  name="accountType"
                  id="accountType"
                  value={
                    checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)
                      ? onlyLastFourNum(values.accountType)
                      : values.accountType
                  }
                  className="w-[300px] md:w-[500px]"
                  onChange={(event: any) => {
                    setFieldValue('accountType', event.target.value);
                  }}
                  error={Boolean(touched.accountType && errors.accountType)}
                  displayEmpty
                  defaultValue=""
                  sx={{ width: '80%' }}
                >
                  <MenuItem disabled value="">
                    Select Option
                  </MenuItem>
                  {accountType?.map((item: any) => (
                    <MenuItem key={item.code} value={item.code}>
                      {item.displayValue}
                    </MenuItem>
                  ))}
                </Select>
                {errors.accountType && (
                  <Typography color="error" variant="body2">
                    {errors.accountType}
                  </Typography>
                )}
              </Box>

              {/* Business Type */}
              <Box width="100%">
                <Typography variant="h5" gutterBottom component="div">
                  Business Type
                </Typography>
                <Select
                  disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)}
                  name="businessType"
                  id="businessType"
                  value={
                    checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions)
                      ? onlyLastFourNum(values.businessType)
                      : values.businessType
                  }
                  className="w-[300px] md:w-[500px]"
                  onChange={(event: any) => {
                    setFieldValue('businessType', event.target.value);
                  }}
                  error={Boolean(touched.businessType && errors.businessType)}
                  displayEmpty
                  defaultValue=""
                  sx={{ width: '80%' }}
                >
                  <MenuItem disabled value="">
                    Select Option
                  </MenuItem>
                  {businessType?.map((item: any) => (
                    <MenuItem key={item.code} value={item.code}>
                      {item.displayValue}
                    </MenuItem>
                  ))}
                </Select>
                {errors.businessType && (
                  <Typography color="error" variant="body2">
                    {errors.businessType}
                  </Typography>
                )}
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    CIN Number
                  </Typography>
                  <TextField
                    disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                    sx={{ width: '80%' }}
                    placeholder="CIN Number"
                    name={'cinNumber'}
                    name={'cinNumber'}
                    value={values.cinNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.cinNumber && errors.cinNumber)}
                    helperText={touched.cinNumber && errors.cinNumber}
                  />
                </Stack>
              </Box>

            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Bank Account Type
                  </Typography>
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="bankAccountType"
                      value={values.bankAccountType}
                      name="bankAccountType"
                      onChange={handleChange}
                    >
                      <FormControlLabel value="SAVING_ACCOUNT" control={<Radio />} label="Saving Account " />
                      <FormControlLabel value="CURRENT_ACCOUNT" control={<Radio />} label="Current Account" />
                    </RadioGroup>
                  </FormControl>
                </Stack>
              </Box>
            </Box>
            <Box sx={{ marginTop: '25px' }}>
              <Box display={'flex'} flexDirection={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} marginTop={'25px'}>
                <Box sx={{ width: { xs: '100%', sm: state.editMode === false ? '100%' : '50%' } }}>
                  <Stack direction="column" alignItems="self-start">
                    <Typography variant="h5" gutterBottom component="div">
                      Vendor's GST Identification
                    </Typography>
                    <TextField
                      disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                      sx={{ width: { xs: '100%', sm: state.editMode === false ? '90%' : '82%' } }}
                      placeholder="Vendor's GST Identification"
                      name={'gstNo'}
                      value={values.gstNo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.gstNo && errors.gstNo)}
                      helperText={touched.gstNo && errors.gstNo}
                    />
                  </Stack>
                </Box>
                {state.editMode !== false && (
                  <Box sx={{ marginTop: { xs: '20px', sm: '0' }, width: '100%' }}>
                    <Box alignItems={'flex-start'} marginTop={'10px'}>
                      <Box width="50%">
                        <Stack direction="column" alignItems="self-start">
                          <Typography variant="h5" gutterBottom component="div">
                            GST Upload
                          </Typography>
                        </Stack>
                      </Box>
                      <div style={{ display: 'flex ', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'flex-start' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <div>
                            <input
                              id="input"
                              type="file"
                              accept=".png, .jpg, .jpeg , .pdf, .docx"
                              name="file"
                              ref={fileInputForW9}
                              onChange={(e) => {
                                changeHandlerForAdhar(e);
                              }}
                            />
                          </div>
                          <div>
                            {GSTUrl === null && (
                              <p style={{ marginTop: '5px', fontSize: '11px', color: 'red' }}>Please Upload File</p>
                            )}
                            <p style={{ marginTop: '8px', fontSize: '12px' }}>
                              Allowed *.jpeg, *.jpg, *.png, *.pdf, *.docx
                            </p>
                          </div>
                        </div>
                        <div>
                          {GSTUrl !== null && (
                            <div>
                              <td
                                style={{
                                  color: 'blue',
                                  width: '28%',
                                  cursor: 'pointer',
                                }}
                                onClick={() => window.open(GSTUrl, '_blank')}
                                href={GSTUrl}
                                target="_blank"
                              >
                                {' '}
                                Download GST
                              </td>
                            </div>
                          )}
                        </div>
                        <div>
                          <Button
                            style={{ color: 'white', backgroundColor: '#E23744', marginLeft: { xs: '0', sm: '20px' }, marginTop: { xs: '10px', sm: '0' } }}
                            variant="contained"
                            color="error"
                            onClick={() => {
                              uploadFileForW9('GST');
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </div>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
            <Box sx={{ marginTop: '25px' }}>
              <Box display={'flex'} flexDirection={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} marginTop={'25px'}>
                <Box sx={{ width: { xs: '100%', sm: state.editMode === false ? '100%' : '50%' } }}>
                  <Stack direction="column" alignItems="self-start">
                    <Typography variant="h5" gutterBottom component="div">
                      Vendor's PAN Card
                    </Typography>
                    <TextField
                      disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                      sx={{ width: { xs: '100%', sm: state.editMode === false ? '90%' : '82%' } }}
                      placeholder="Vendor's PAN Card"
                      name={'employerIdentificationNumber'}
                      value={values.employerIdentificationNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.employerIdentificationNumber && errors.employerIdentificationNumber)}
                      helperText={touched.employerIdentificationNumber && errors.employerIdentificationNumber}
                    />
                  </Stack>
                </Box>
                {state.editMode !== false && (
                  <Box sx={{ marginTop: { xs: '20px', sm: '0' }, width: '100%' }}>
                    <Box alignItems={'flex-start'} marginTop={'10px'}>
                      <Box width="50%">
                        <Stack direction="column" alignItems="self-start">
                          <Typography variant="h5" gutterBottom component="div">
                            PAN Card Upload
                          </Typography>
                        </Stack>
                      </Box>
                      <div style={{ display: 'flex ', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'flex-start' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <div>
                            <input
                              id="input"
                              type="file"
                              accept=".png, .jpg, .jpeg , .pdf, .docx"
                              name="file"
                              ref={fileInputForW9}
                              onChange={(e) => {
                                changeHandlerForAdhar(e);
                              }}
                            />
                          </div>
                          <div>
                            {PanCardUrl === null && (
                              <p style={{ marginTop: '5px', fontSize: '11px', color: 'red' }}>Please Upload File</p>
                            )}
                            <p style={{ marginTop: '8px', fontSize: '12px' }}>
                              Allowed *.jpeg, *.jpg, *.png, *.pdf, *.docx
                            </p>
                          </div>
                        </div>
                        <div>
                          {PanCardUrl !== null && (
                            <div>
                              <td
                                style={{
                                  color: 'blue',
                                  width: '28%',
                                  cursor: 'pointer',
                                }}
                                onClick={() => window.open(PanCardUrl, '_blank')}
                                href={PanCardUrl}
                                target="_blank"
                              >
                                {' '}
                                Download PAN Card
                              </td>
                            </div>
                          )}
                        </div>
                        <div>
                          <Button
                            style={{ color: 'white', backgroundColor: '#E23744', marginLeft: { xs: '0', sm: '20px' }, marginTop: { xs: '10px', sm: '0' } }}
                            variant="contained"
                            color="error"
                            onClick={() => {
                              uploadFileForW9('PANCARD');
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </div>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
            <Box sx={{ marginTop: '25px' }}>
              <Box display={'flex'} flexDirection={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} marginTop={'25px'}>
                <Box sx={{ width: { xs: '100%', sm: state.editMode === false ? '100%' : '50%' } }}>
                  <Stack direction="column" alignItems="self-start">
                    <Typography variant="h5" gutterBottom component="div">
                      Aadhar Card
                    </Typography>
                    <TextField
                      disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                      sx={{ width: { xs: '100%', sm: state.editMode === false ? '90%' : '82%' } }}
                      placeholder="Vendor's Aadhar Card"
                      name={'aadharCard'}
                      value={values.aadharCard}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.aadharCard && errors.aadharCard)}
                      helperText={touched.aadharCard && errors.aadharCard}
                    />
                  </Stack>
                </Box>
                {state.editMode === false ? (
                  ''
                ) : (
                  <Box sx={{ marginTop: { xs: '20px', sm: '0' }, width: '100%' }}>
                    <Box alignItems={'flex-start'} marginTop={'10px'}>
                      <Box width="50%">
                        <Stack direction="column" alignItems="self-start">
                          <Typography variant="h5" gutterBottom component="div">
                            Aadhar Card Upload
                          </Typography>
                        </Stack>
                      </Box>
                      <div style={{ display: 'flex ', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'flex-start' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <div>
                            <input
                              id="input"
                              type="file"
                              accept=".png, .jpg, .jpeg , .pdf, .docx"
                              name="file"
                              ref={fileInputForW9}
                              onChange={(e) => {
                                changeHandlerForAdhar(e);
                              }}
                            />
                          </div>

                          <div>
                            {AaharUrl === null && (
                              <p style={{ marginTop: '5px', fontSize: '11px', color: 'red' }}>Please Upload File</p>
                            )}
                            <p style={{ marginTop: '8px', fontSize: '12px' }}>
                              Allowed *.jpeg, *.jpg, *.png, *.pdf, *.docx
                            </p>
                          </div>
                        </div>

                        <div>
                          {AaharUrl !== null && (
                            <div>
                              <td
                                style={{
                                  color: 'blue',
                                  width: '28%',
                                  cursor: 'pointer',
                                }}
                                onClick={() => window.open(AaharUrl, '_blank')}
                                href={AaharUrl}
                              >
                                Download Aadhar Card
                              </td>
                            </div>
                          )}
                        </div>
                        <div>
                          <Button
                            style={{ color: 'white', backgroundColor: '#E23744', marginLeft: { xs: '0', sm: '20px' }, marginTop: { xs: '10px', sm: '0' } }}
                            variant="contained"
                            color="error"
                            onClick={() => {
                              uploadFileForW9('AADHAR');
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </div>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
            {state.editMode === false ? (
              ''
            ) : (
              <Box sx={{ marginTop: '25px' }}>
                <Box alignItems={'center'} marginTop={'10px'}>
                  <Box width="50%">
                    <Stack direction="column" alignItems="self-start">
                      <Typography variant="h5" gutterBottom component="div">
                        Contract Upload
                      </Typography>
                    </Stack>
                  </Box>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      gap: '10px',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div>
                        <input
                          id="input"
                          type="file"
                          accept=".png, .jpg, .jpeg , .pdf, .docx"
                          name="file"
                          ref={fileInputForW9}
                          onChange={(e) => {
                            changeHandlerForAdhar(e);
                          }}
                        />
                      </div>

                      <div>
                        {contractUrl === null && (
                          <p style={{ marginTop: '5px', fontSize: '11px', color: 'red' }}>Please Upload File</p>
                        )}
                        <p style={{ marginTop: '8px', fontSize: '12px' }}>
                          Allowed *.jpeg, *.jpg, *.png, *.pdf, *.docx
                        </p>
                      </div>
                    </div>

                    <div>
                      {contractUrl !== null && (
                        <div>
                          <td
                            style={{
                              color: 'blue',
                              width: '28%',
                              cursor: 'pointer',
                            }}
                            onClick={() => window.open(contractUrl, '_blank')}
                            href={contractUrl}
                          >
                            Download Contract
                          </td>
                        </div>
                      )}
                    </div>
                    <div>
                      <Button
                        style={{ color: 'white', backgroundColor: '#E23744', marginLeft: '20px' }}
                        variant="contained"
                        color="error"
                        onClick={() => {
                          uploadFileForW9('CONTRACT');
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </Box>
              </Box>
            )}
            {/**<Box style={{ marginTop: '10px' }}>
              <Box width="50%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Company Logo
                  </Typography>
                </Stack>
              </Box>
              <div style={{ display: 'flex ', flexDirection: 'row' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div>
                    <input
                      id="input"
                      type="file"
                      accept="image/*"
                      name="file"
                      ref={fileInputForW9}
                      onChange={(e) => {
                        changeHandlerProfileImage(e);
                      }}
                    />
                  </div>

                  <div>
                    <p style={{ marginTop: '8px', fontSize: '12px' }}>Allowed only *.jpeg, *.jpg, *.png</p>
                  </div>
                </div>

                <div>
                  {isImgUrl !== null && (
                    <div>
                      <td
                        style={{
                          color: 'blue',
                          width: '28%',
                          cursor: 'pointer',
                        }}
                        onClick={() => window.open(isImgUrl, '_blank')}
                        href={isImgUrl}
                      >
                        Download Logo
                      </td>
                    </div>
                  )}
                </div>
                <div>
                  <Button
                    style={{ color: 'white', backgroundColor: '#E23744', marginLeft: '20px' }}
                    variant="contained"
                    color="error"
                    onClick={() => {
                      uploadFileForW9('COMPANY_LOGO');
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </Box> */}
            <Box style={{ marginTop: '10px' }}>
              <Box width="50%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Company Logo
                  </Typography>
                </Stack>
              </Box>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  gap: '10px',
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div>
                    <input
                      id="input"
                      type="file"
                      accept="image/*"
                      name="file"
                      ref={fileInputForW9}
                      onChange={(e) => {
                        changeHandlerProfileImage(e);
                      }}
                    />
                  </div>

                  <div>
                    <p style={{ marginTop: '8px', fontSize: '12px' }}>Allowed only *.jpeg, *.jpg, *.png</p>
                  </div>
                </div>

                <div>
                  {isImgUrl !== null && (
                    <div>
                      <td
                        style={{
                          color: 'blue',
                          width: '28%',
                          cursor: 'pointer',
                        }}
                        onClick={() => window.open(isImgUrl, '_blank')}
                        href={isImgUrl}
                      >
                        Download Logo
                      </td>
                    </div>
                  )}
                </div>

                <div>
                  <Button
                    style={{ color: 'white', backgroundColor: '#E23744', marginLeft: '20px' }}
                    variant="contained"
                    color="error"
                    onClick={() => {
                      uploadFileForW9('COMPANY_LOGO');
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </Box>
            <Box marginTop={'25px'}>
              <Stack direction="column" alignItems="self-start">
                <Typography variant="h5" gutterBottom component="div">
                  Vendor Commission (%)
                </Typography>
                <TextField
                  disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                  sx={{ width: '90%' }}
                  placeholder="Enter vendor commission (%)"
                  value={values.commission}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name={'commission'}
                  error={Boolean(touched.commission && errors.commission)}
                  helperText={touched.commission && errors.commission}
                />
              </Stack>
            </Box>
            <Box marginTop={'25px'}>
              <Stack direction="column" alignItems="self-start">
                <Typography variant="h5" gutterBottom component="div">
                  Vendor Convenience fee
                </Typography>
                <TextField
                  disabled={checkPermissions(PERMISSION.VENDOR_HIDE_DETAIL, token.permissions) ? true : false}
                  sx={{ width: '90%' }}
                  placeholder="Vendor Convenience fee"
                  value={values.convenienceFee}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name={'convenienceFee'}
                  error={Boolean(touched.convenienceFee && errors.commission)}
                  helperText={touched.convenienceFee && errors.convenienceFee}
                />
              </Stack>
            </Box>
            <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end', marginRight: '100px' }}>
              <Button
                style={{ color: 'white', backgroundColor: '#E23744' }}
                variant="contained"
                color="error"
                onClick={() => {
                  {
                    state.isApproved ? navigate('/dashboard/view-request') : navigate('/dashboard/vendor-details');
                  }
                }}
                sx={{ marginRight: '10px' }}
                size="large"
              >
                Cancel
              </Button>
              <Button
                // style={{ color: 'white', backgroundColor: '#E23744' }}
                variant="contained"
                onClick={() => {
                  handleSubmit();
                  setFrom('F');
                }}
                disabled={state.isApproved && values.status === false ? true : false}
                size="large"
                sx={{ marginRight: '10px' }}
                type="submit"
              >
                {state.editMode ? 'Update' : state.isApproved ? 'Final Approve' : 'Add'}
              </Button>

              {state.isApproved && (
                <Button
                  style={{
                    color: 'white',
                    backgroundColor: state.isApproved && values.status === true ? 'grey' : '#E23744',
                  }}
                  variant="contained"
                  disabled={state.isApproved && values.status === true}
                  onClick={async () => {
                    // 1. Mark all fields as touched
                    Object.keys(values).forEach((field) => {
                      setFieldTouched(field, true, true);
                    });
                  
                    // 2. Validate the form
                    const formErrors = await validateForm();
                    console.log(formErrors ,"formErrors");
                  
                    // 3. If errors exist, do NOT proceed
                    if (Object.keys(formErrors).length > 0) {
                      // Optionally: Scroll to first error or show toast here
                      return;
                    }
                  
                    // 4. If no errors, proceed
                    setFrom('T');
                    temporaryUpdateDataInServe(values);
                  }}
                  
                  color="success"
                  size="large"
                  type="submit"
                >
                  Temporary Approve
                </Button>

              )}
            </div>
          </Container>
        )}
      </Formik>
      {saveResponse.isLoading ||
        deleteDocumentRes.isLoading ||
        getDocumentResponse.isLoading ||
        uploadFormResponse.isLoading ||
        getAllResponse.isLoading ||
        findByIdResponse.isLoading ||
        updateResponse.isLoading ? (
        <Loading />
      ) : null}
    </Page>
  );
}
